// extracted by mini-css-extract-plugin
export const homeIntro = "HomeIntro-module--home-intro--3XpYK";
export const homeIntro__content = "HomeIntro-module--home-intro__content--QBgNF";
export const homeIntro__text = "HomeIntro-module--home-intro__text--vh05E";
export const homeIntro__textWhite = "HomeIntro-module--home-intro__text--white--JP0Si";